module.exports = __webpack_public_path__ + "img/yishiguohuo.a10b79c7.png";